module.exports = __webpack_public_path__ + "img/20191230155533454.7c4b0e53.jpg";